define.alias("shared/components/shared/social/refresh-profile/snapchat", "calendar/components/shared/social/refresh-profile/snapchat");